import React, { useState, useRef } from 'react';
import {default as CurrencyInputField}  from 'react-currency-input-field';
import { getGlobalCurrencySymbol } from 'lib/utils/currency';
import Button from '../Button';

const CurrencyInput = (props) => {
    const [editing, setEditing] = useState(false);

    let input = useRef(null);

    const toggleEditSave = () => {
        if (editing) {
            let v = input.current.value;
            v = v.replace(/[^\d.]/g, '');
            if (props.onSave) props.onSave(v);
            return setEditing(false);
        }

        input.current.focus();
        setTimeout(() => {
            input.current.focus();
        });
        return setEditing(true)
    }

    const onKeyPress = (e) => {
        if (e.charCode == 13) {
            toggleEditSave();
        }
    }

    const onChange = (v) => {
        if (props.onChange) props.onChange(v);
    }

    return (
        <div className={"currency-input " + (props.color ? props.color : '') + (props.className ? ` ${props.className}` : '')}>

            <CurrencyInputField ref={input} key={props.name}
                className="input simple"
                onKeyPress={onKeyPress}
                onValueChange={onChange}
                value={props.value}
                defaultValue={props.defaultValue}
                disabled={(!editing && !props.noEditButton) || !props.canEdit}
                prefix={props.prefix === false ? "" : props.prefix || getGlobalCurrencySymbol()}
                decimalScale={parseInt(props.precision || 0)}
                maxLength={1000000000}
            />

            { props.canEdit && !props.noEditButton &&
                <Button className={ 'edit-button ' + (props.buttonClass || '') } onClick={() => toggleEditSave()} {...(props.buttonProps || {})}>{editing ? 'Save' : 'Edit'}</Button>
            }
        </div>
    )
}

export default CurrencyInput;